import { useEffect, useRef } from 'react'

/** Открытые окна по порядку: Esc закрывает только верхнее. */
const stack: { close: () => void }[] = []

/**
 * Esc закрывает модальное окно.
 *
 * Слушатель на document, поэтому срабатывает и когда фокус внутри поля ввода.
 * Когда окон два (задача и поверх неё оценка), закрывается только верхнее —
 * иначе Esc схлопывал бы сразу оба. Колбэк держим в ref, чтобы эффект не
 * перезапускался на каждый рендер родителя и порядок стопки не ломался.
 */
export function useEscClose(onClose: () => void) {
  const latest = useRef(onClose)
  latest.current = onClose

  useEffect(() => {
    const entry = { close: () => latest.current() }
    stack.push(entry)

    const onKey = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return
      if (stack[stack.length - 1] !== entry) return
      e.preventDefault()
      entry.close()
    }
    document.addEventListener('keydown', onKey)

    return () => {
      document.removeEventListener('keydown', onKey)
      const i = stack.indexOf(entry)
      if (i >= 0) stack.splice(i, 1)
    }
  }, [])
}
